import { useMutation, useQueryClient } from "@tanstack/react-query";
import OnlineOrderActions from "../../../OnlineOrderActions";
import { useOktaAuth } from "@okta/okta-react";
import { useHistory } from "react-router-dom";
import toastMessages from "../../helpers/toastMessage";

function useDeleteOrder({ closePopup }: { closePopup?: Function }) {
  const data = useOktaAuth();
  const authState = data?.authState;
  const queryClient = useQueryClient();
  const history = useHistory();

  return useMutation({
    mutationKey: ["deleteOrder"],
    mutationFn: (id: string) => {
      const orderActions = new OnlineOrderActions(null, null, null, [], "");
      return orderActions.deleteOrder({
        id,
        token: authState?.accessToken?.accessToken ?? "",
      });
    },
    retry: false,
    onSuccess: (res) => {
      toastMessages.success("Order deleted successfully");
      queryClient?.invalidateQueries({ queryKey: ["testsList"] });
      closePopup?.();
      history?.replace("/access/test-orders");
      
    },
    onError: () => {
      toastMessages.error("Failed to delete order");
      closePopup?.();
    },
  });
}

export default useDeleteOrder;
